import React, { useState, useEffect } from "react"
import Select from "react-select"
import { get } from "utils/apiClient"

const AppointmentSystemSelector = ({ value = [], onChange, disabled = false }) => {
  const [allApptSys, setAllApptSys] = useState([])
  const [loading, setLoading] = useState(false)

  const normalizedValue = React.useMemo(() => {
    if (Array.isArray(value)) {
      return value.filter(v => v && v.trim())
    }
    if (typeof value === 'string' && value) {
      return value.split(',').map(v => v.trim()).filter(v => v)
    }
    return []
  }, [value])

  useEffect(() => {
    loadAllApptSys()
  }, [])

  const loadAllApptSys = async () => {
    try {
      setLoading(true)
      const response = await get("appt-sys/all")
      const appt_sys = response ? response.map((item) => ({
        value: item.key,
        label: item.key,
      })) : []
      setAllApptSys(appt_sys)
    } catch (error) {
      console.error("Error loading appointment systems:", error)
      setAllApptSys([])
    } finally {
      setLoading(false)
    }
  }

  const handleSelectChange = (selectedOption) => {
    if (selectedOption && selectedOption.value && !normalizedValue.includes(selectedOption.value)) {
      const newValue = [...normalizedValue, selectedOption.value]
      onChange(newValue)
    }
  }

  const handleRemoveSystem = (systemToRemove) => {
    const newValue = normalizedValue.filter(system => system !== systemToRemove)
    onChange(newValue)
  }

  const availableOptions = allApptSys.filter(option => !normalizedValue.includes(option.value))

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: base.borderColor,
      "&:hover": {
        borderColor: base.borderColor,
      },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, 
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, 
    }),
  }

  return (
    <div>
      <div className="text-muted d-block mb-2" style={{ fontSize: "0.8rem" }}>
        Select appointment systems from the dropdown below
      </div>
      <div className="mb-2">
        <Select
          options={availableOptions}
          value={null}
          onChange={handleSelectChange}
          isMulti={false}
          isSearchable
          isClearable
          isDisabled={disabled || loading}
          placeholder={loading ? "Loading appointment systems..." : "Search and select appointment systems..."}
          styles={customStyles}
          className="select2-selection"
          noOptionsMessage={() => availableOptions.length === 0 ? "All systems selected" : "No appointment systems found"}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </div>

      {normalizedValue.length > 0 && (
        <div className="mb-2">
          <small className="text-muted d-block mb-2">Selected systems:</small>
          {normalizedValue.map((system, index) => (
            <span
              key={index}
              className="me-1 mb-1 d-inline-flex align-items-center"
              style={{
                fontSize: "0.75rem",
                padding: "0.35rem 0.6rem",
                backgroundColor: "#F25A29",
                borderColor: "#F25A29",
                color: "white",
                borderRadius: "0.25rem",
                border: "1px solid #F25A29"
              }}
            >
              {system}
              {!disabled && (
                <button
                  type="button"
                  className="btn-close ms-1"
                  style={{ fontSize: "0.5rem", width: "14px", height: "14px" }}
                  onClick={() => handleRemoveSystem(system)}
                  aria-label="Remove"
                />
              )}
            </span>
          ))}
        </div>
      )}

    </div>
  )
}

export default AppointmentSystemSelector